// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__284Gj","title":"ClientReferral_title__1vwDa","itemText":"ClientReferral_itemText__2YFit"};